<template>
  <!-- <div class="task-box"
  @mouseover="showBtnArea = true" @mouseleave="showBtnArea = false; searchVisbileUserPopVisible = false"> -->
  <div class="task-box"> 
  <Modal v-model="deleteRecordModal" @on-ok="deleteRecord">
      <p>您确认要删除此条任务记录吗？</p>
    </Modal>
    <div class="task-info-bar">
      <!-- <div style="width: 64px">
        
        <Dropdown
          @on-click="selectCategory"
          trigger="hover"
          style="margin-right: 12px; cursor: pointer"
          placement="bottom-start"
        >
          <span>
            {{ catTrans[task.category] ?? '无分类' }}
          </span>
          <DropdownMenu slot="list">
            <DropdownItem name="sales">销售</DropdownItem>
            <DropdownItem name="research">研发</DropdownItem>
            <DropdownItem name="techservice">技服</DropdownItem>
            <DropdownItem name="factory">厂务</DropdownItem>
            <DropdownItem name="shipping">运输</DropdownItem>
            <DropdownItem name="office">总经办</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      
      <div style="width: 64px">
        {{ progressText[task.progress] }}
      </div> -->
    </div>

    <div class="task-area">
      <div class="col  col-small" >
        <div style="font-size: 12px; color: rgb(95, 95, 95);">
          {{ displayDate(task.createdAt) }} 
        </div>
      </div>

      <div class="col col-small">
        <Poptip
          v-model="searchUserPopVisible"
          placement="right"
          transfer
          @on-popper-show="searchUserShow('search-user')">
          <div v-if="task.mainResponsible">
            {{ task.mainResponsible?.name }}
          </div>
          <div v-else style="color: darkgray">
            无
          </div>

          <template slot="content">
            <Row>
              <Input
                ref="search-user"
                placeholder="搜索用户"
                v-model="searchUserText"
                size="small"
                ></Input>
            </Row>
            <div class="user-area">
              <div v-for="user in simpleUserList.filter(v => v.name.includes(searchUserText))" class="user-card">
                {{ user.name }}
              </div>
            </div>
          </template>
        </Poptip>
      </div>


      <div class="col" style="width: 593px; font-weight: 700;" @click="clickField('title')">
        
        <div v-if="fieldEditing === 'title'">
          <Input
            ref="input-title"
            v-model="fieldEditingValue"
            placeholder="输入任务标题"
            :border="false"
            type="textarea"
            @on-blur="finishEditField()"
            :autosize="{minRows: 1,maxRows: 30}"
            ></Input>
        </div>
        <div v-else style="font-size: 14px">
          {{ task.title }}
        </div>
      </div>

      <div class="col col-small" @click="clickField('deadLine')">

        <div v-if="fieldEditing === 'deadLine'">
          <Input
            ref="input-deadLine"
            v-model="fieldEditingValue"
            placeholder="时间"
            :border="false"
            size="small"
            @on-blur="finishEditField()"
            @on-enter="finishEditField()"
            ></Input>
        </div>
        <div v-else>
          <div v-if="task.deadLine">
            {{ displayDate(task.deadLine) }}
          </div>
          <div v-else class="gray-out">
            无
          </div>
        </div>
        
      </div>

      <div class="col col-small">
        <Dropdown 
          @on-click="updateTaskProgress"
          trigger="click"
          style="margin-right: 12px; cursor: pointer;"
          placement="bottom-start"
        >
          <div v-if="progressText[task.progress]">
            {{ progressText[task.progress] }}
          </div>
          <div style="color: darkgray;" v-else>
            无
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="created">未完成</DropdownItem>
            <DropdownItem name="finished">已完成</DropdownItem>
            <DropdownItem name="canceled" divided>取消</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>

      <div class="col col-small">
        <Dropdown 
            @on-click="selectCategory"
            trigger="click"
            style="margin-right: 12px; cursor: pointer;"
            placement="bottom-start"
          >
            <div style="width: 56px; height: 100%;" v-if="catTrans[task.category]">
              {{ catTrans[task.category]}}
            </div>
            <div style="width: 56px; height: 100%; color: darkgray;" v-else>
              无
            </div>
            <DropdownMenu slot="list">
              <DropdownItem name="sales">销售</DropdownItem>
              <DropdownItem name="research">研发</DropdownItem>
              <DropdownItem name="techservice">技服</DropdownItem>
              <DropdownItem name="factory">厂务</DropdownItem>
              <DropdownItem name="shipping">运输</DropdownItem>
              <DropdownItem name="fin">财务</DropdownItem>
              <DropdownItem name="office">总经办</DropdownItem>
            </DropdownMenu>
          </Dropdown>
      </div>


      <div class="col col-small gray-out">
        {{ task.createdBy?.name }}
      </div>

      <div class="col" style="width: 24px; padding: 4px; cursor: default;">
        <Icon type="md-trash" class="delete-btn"/>
      </div>
    </div>

    <Transition name="btn-row">
      <div class="btn-area" v-show="showBtnArea">
        <Button
          @click="createNewRecordBtnClicked"
          type="text"
          icon="ios-add"
          >新增进度
        </Button>

        
        <Poptip
          v-model="searchVisbileUserPopVisible"
          placement="top-start"
          @on-popper-show="searchUserShow('search-user-visible')">
          <!-- <div style="margin-top: 4px; cursor: pointer;">
            可见人：{{ task.visibleMember.map(v => v.name).join('、') || '点击添加'}}
          </div> -->
          <div style="margin-top: 4px; cursor: pointer;">
            可见人：{{ task.visibleMember && task.visibleMember.length > 0 ? task.visibleMember.map(v => v.name).join('、') : '点击添加' }}
          </div>

          <template slot="content">
            <Row>
              <Input
                ref="search-user-visible"
                placeholder="搜索用户"
                v-model="searchUserText"
                size="small"
                ></Input>
            </Row>
            <div class="user-area">
              <div v-for="user in simpleUserList.filter(v => v.name.includes(searchUserText))" class="user-card">
                <div v-if="task.visibleMember && task.visibleMember.length > 0 ? task.visibleMember.map(v => v._id).includes(user._id) : false" style="color: blue"  @click="selectVisibleUser(user._id, 'delete')">
                  {{ user.name }}
                </div>
                <div v-else  @click="selectVisibleUser(user._id, 'add')">
                  {{ user.name }}
                </div>
              </div>
            </div>
          </template>
        </Poptip>

        <div v-if="newRecordCreating === true" style="margin: 4px 12px">
          <Input ref="new-record" v-model="newRecordContent" type="textarea" placeholder="输入跟进记录..." @on-enter="createNewRecord" :rows='textareaRows'/>
          <div style="margin: 8px 0">
            <Button @click="createNewRecord" size="small" type="primary" style="margin-right: 8px">保存</Button>
            <Button @click="newRecordCreating = false; newRecordContent = null" size="small">取消</Button>
          </div>
        </div>

        
      </div>
    </Transition>
    

    <div>
      <div v-for="(record, index) in [...task.records].reverse()">
        <div class="record-row">
          <div class="col" style="width: 128px; color: rgb(95, 95, 95);">
            {{ displayDate(record?.createdAt) }}
          </div>

          <div class="col" style="width: 785px;" @click="clickField('record-content', index)">
            
            <div v-if="fieldEditing === 'record-content' && recordEditingIndex === index">
              <Input
                :ref="`record-content-${index}`"
                v-model="fieldEditingValue"
                placeholder="输入任务标题"
                :border="false"
                type="textarea"
                @on-blur="finishEditField()"
                :autosize="{minRows: 1,maxRows: 30}"
                ></Input>
            </div>
            <div v-else style="font-size: 14px">
              {{ record?.content }}
            </div>
          </div>

          <div class="col col-small gray-out">
            {{ record?.createdBy?.name }}
          </div>

          <div class="col" style="width: 24px; padding: 4px; cursor: default;">
            <Icon type="md-trash" class="delete-btn" @click="openDelRecordModal(record)"/>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapState } from "vuex";
import { arrayIntersection } from "@/utils";

export default {
  props: {
    task: {
      default: {},
    }
  },
  name: "TaskBox",
  data() {
    return {
      catTrans: {
        sales: '销售',
        research: '研发',
        techservice: '销售',
        factory: '厂务',
        shipping: '运输',
        fin: '财务',
        office: '总经办'
      },
      progressText: {
        created: "未完成",
        inProgress: "进行中",
        reviewing: "审查中",
        finished: "已完成",
        canceled: "取消",
        failed: "失败",
      },
      drawerOpened: false,
      openedTask: null,
      newRecordCreating: false,
      newRecordContent: '',
      fieldEditing: null,
      recordEditingIndex: null,
      fieldEditingValue: null,
      showBtnArea: true,
      searchUserPopVisible: false,
      searchUserText: '',
      deadLinePopVisible: false,
      searchVisbileUserPopVisible: false,
      deleteRecordModal: false,
      selectRecord: {},
      textareaRows: 3
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
      simpleUserList: (state) => state.user.simpleUserList,
    }),
    createdAtDisplay() {
      return dayjs(this.task.createdAt)
        .format("M月D日")
    },
    displayDate(v) {
      return (v) => {
        if (!v) {
          return;
        } else {
          return dayjs(v).format("M月D日")
        }
        
      }
    },
  },
  methods: {
    ...mapActions({
      getUsers: "user/getUsersAction",
      createTask: "task/createTaskAction",
      updateTask: "task/updateTaskAction",
      deleteTask: "task/deleteTaskAction",
      createTaskRecord: "task/createTaskRecordAction",
      updateTaskRecord: "task/updateTaskRecordAction",
      deleteTaskRecord: "task/deleteTaskRecordAction",
    }),
    async selectCategory(category) {
      try {
        await this.updateTask({
          id: this.task._id,
          data: { category: category },
        });
      } catch (error) {
        this.$Message.error('修改失败')
      }
    },
    createNewRecordBtnClicked() {
      this.newRecordCreating = true;
      this.focusRef('new-record')
      // this.$nextTick(() => {
      //   // 这个refs很离谱的变成了一个array
      //   this.$refs[`new-record`].focus({
      //     cursor: 'end'
      //   });
      // })
    },
    async createNewRecord() {
      await this.createTaskRecord({ taskId: this.task._id, data: { content: this.newRecordContent } });
      this.newRecordCreating = false;
      this.newRecordContent = null;
    },
    async updateRecord() {
      await this.updateTaskRecord({ taskId: this.task._id, data: { content: this.newRecordContent } });
    },
    openDelRecordModal(record) {
      this.deleteRecordModal = true
      this.selectRecord = record
    },
    async deleteRecord() {
      await this.deleteTaskRecord({ taskId: this.task._id, data: { recordId: this.selectRecord._id } });
    },
    clickField(field, recordEditingIndex) {
      if (this.fieldEditing === field && this.recordEditingIndex === recordEditingIndex) return;
      this.fieldEditing = field;
      this.recordEditingIndex = recordEditingIndex;

      if (field === 'title') {
        this.fieldEditingValue = this.task.title;
        // this.$nextTick(() => {
        //   this.$refs[`input-${field}`].focus({
        //     cursor: 'end'
        //   });
        // })
        this.focusRef(`input-${field}`)
      }

      if (field === 'record-content') {
        this.fieldEditingValue = this.task.records[recordEditingIndex]?.content;
        this.$nextTick(() => {
          // 这个refs很离谱的变成了一个array
          const a = `record-content-${recordEditingIndex}`
          this.$refs[a][0].focus({
            cursor: 'end'
          });
        })
      }

      if (field === 'deadLine') {
        if (this.task.deadLine) {
          this.fieldEditingValue = dayjs(this.task.deadLine).format('M.D')
        }
        // this.$nextTick(() => {
        //   this.$refs[`input-${field}`].focus({
        //     cursor: 'end'
        //   });
        // })
        this.focusRef(`input-${field}`);
      }
      
    },
    async finishEditField() {
      if (this.fieldEditing === 'title' && this.fieldEditingValue !== this.task.title) {
        try {
          await this.updateTask({
            id: this.task._id,
            data: { title: this.fieldEditingValue }
          })
          // this.$Message.success('成功')
        } catch (error) {
          this.$Message.error('修改失败')
        }
      }

      if (this.fieldEditing === 'record-content') {
        try {
          await this.updateTaskRecord({
            taskId: this.task._id,
            recordId: this.task.records[this.recordEditingIndex]._id,
            data: { content: this.fieldEditingValue }
          })
          // this.$Message.success('成功')
        } catch (error) {
          this.$Message.error('修改失败')
        }
      }

      if (this.fieldEditing === 'deadLine' && typeof this.fieldEditingValue === 'string') {
        const dlText = this.fieldEditingValue.trim();

        if (this.task.deadLine) {
          const originDeadLineText = dayjs(this.task.deadLine).format('M.D');
          if (originDeadLineText === dlText) {
            this.fieldEditingValue = null
            this.fieldEditing = null;
            this.recordEditingIndex = null;
            return;
          }
        }
        
        if (dayjs(dlText).isValid()) {
          let newDeadLine = dayjs(dlText);
          if (newDeadLine.year() === 2001) {
            const currentYear = dayjs().year();
            newDeadLine = dayjs(dlText).year(currentYear);
          }

          try {
            await this.updateTask({
              id: this.task._id,
              data: { deadLine: newDeadLine }
            })
            // this.$Message.success('成功')
          } catch (error) {
            this.$Message.error('修改失败')
          }
        } else {
          this.$Message.error('无效日期')
        }

        
      }

      this.fieldEditingValue = null
      this.fieldEditing = null;
      this.recordEditingIndex = null;
    },
    async updateTaskProgress(progress) {
      try {
        await this.updateTask({
          id: this.task._id,
          data: { progress }
        })
      } catch (error) {
        this.$Message.error('修改失败')
      }
    },
    searchUserShow(ref) {
      this.searchUserText = '';
      this.focusRef(ref);
    },
    focusRef(ref) {
      this.$nextTick(() => {
        this.$refs[ref].focus({
          cursor: 'end'
        });
      })
    },
    async selectResponsibleUser(userId) {
      try {
        await this.updateTask({
          id: this.task._id,
          data: { mainResponsible: userId }
        })
        // this.$Message.success('成功')
      } catch (error) {
        this.$Message.error('修改失败')
      }
      this.searchUserPopVisible = false;
    },
    async selectVisibleUser(userId, type) {
      let visibleMemberIdList = this.task.visibleMember.map(v => v._id) || [];
      if (type === 'add') {
        if (visibleMemberIdList.includes(userId)) return;
        visibleMemberIdList.push(userId);
      } else {
        if (!visibleMemberIdList.includes(userId)) return;
        visibleMemberIdList = visibleMemberIdList.filter(v => v !== userId);
      }

      try {
        await this.updateTask({
          id: this.task._id,
          data: { visibleMember: visibleMemberIdList }
        })
        // this.$Message.success('成功')
      } catch (error) {
        this.$Message.error('修改失败')
      }
      // this.searchUserPopVisible = false;
    }
  },
  
};
</script>

<style lang="stylus" scoped>

.task-box
  border 1px solid #2d4a85
.task-area
  display flex
  width 100%

.col
  padding 4px 6px
  border 1px solid #ececec
  width 85px
  cursor pointer
  transition .2s

  &:hover
    border 1px solid darkgray
  
.col-small
  width 72px
.gray-out
  color darkgray

.btn-area
  width 100%
  overflow hidden
  // position absolute
  // background-color white
  // z-index 8
  // border-style solid 
  // border-width 0 1px 1px 1px
  // border-color #2d4a85
  // margin 0 -1px

.record-row
  display flex

.delete-btn
  color darkgray
  cursor pointer

// .task-info-bar
//   height 2px
//   font-size 10px
//   background-color #2d4a85
//   color white
//   display flex
//   padding 0 12px

.btn-row-enter-active
  animation: fadein .2s;

.btn-row-leave-active
  animation: fadein .2s reverse;

@keyframes fadein {
  0% {
    transform: translateY(-12px);
    height 0
    opacity 0
  }

  100% {
    transform: translateY(0);
    height 32px
    opacity 1
  }
}

.user-area
  width 180px
  height 160px
  overflow-y auto
  display flex
  flex-wrap wrap
  justify-content flex-start
  align-content flex-start
  margin-top 8px

.user-card
  font-size 12px
  padding 2px 4px
  transition .2s
  cursor pointer
  color #3b3b3b
  &:hover
    color #5a9de4
</style>